<template>
  <div class="taxes-page">
    <div class="stingycat-section">
      <h2>Today's fur-plexing topic? Income Taxes! You know, that chunk of your paycheck that mysteriously vanishes every month? Yep, that one.</h2>
      <div class="stingycat-explanation">
        <p>
          <strong>🐱 A Quick Paws for Thought: </strong>🐱<br><br>
          We've all heard the saying, "Nothing is certain except death and taxes." But remember, we cats have nine lives! That means we've got multiple chances to outwit the tax collector, while you, my dear human, have just one. So let's make it count! 🐾<br><br>
          1️⃣ <b>A Purr-snickety Business:</b> We all love a good sunbeam or a cozy blanket. Similarly, taxes offer us amenities like roads, schools, and healthcare. But ever feel like the sunbeam is too hot or the blanket too tight? Yep, taxes can often feel like that—necessary but overbearing.<br><br>
          2️⃣ <b>The Claws Are Out: </b>Taxes usually end up being your biggest expense. But unlike buying premium catnip or a fancy scratching post, you often don't get to choose how it's used.<br><br>
          3️⃣ <b>A Game of Cat and Mouse:</b> Just like a smart feline pounces at the right moment, be aware of tax laws, deductions, and credits. Waiting for the right moment to "pounce" could mean less money in the government's pocket and more in yours.<br><br>
          Sliding Through the Tax Maze: Use our tax slider to understand how taxes eat into your take-home pay (which is calculated without any other deductions like life insurance, dental etc). Remember, these figures are just paw-sible scenarios; consult your tax advisor for purr-cise advice and remember that there are basic federal and provincial personal income amounts along with a multitude of deductions and credits available which are unique to you just like cat paws are to us. 
          
          <br><br>You've probably noticed your paycheque isn't consistent throughout the year. This is because CPP/QPP ($66600) and EI ($61500) have maximum income amounts for contributions so once you max those out you likely should have a small bump in take-home pay. 
          
          <br><br>Also, bonjour hi, if you are in Quebec CPP doesn't apply as QPP does so we'd advise you to always check with Revenue Quebec as they are the only provincial agency in Canada that does their own thing.  Maybe they are like us cats, aloof and independent!   </p><br><br>
      </div>
    </div>
        <!-- Add a dropdown for province selection -->
        <div class="province-dropdown">
      <label for="province">Select Province:</label>
      <select id="province" v-model="selectedProvince" @change="updateTaxRates">
        <option v-for="(province, index) in provinces" :value="province" :key="index">{{ province }}</option>
      </select>
    </div>
    <div class="tax-slider-section">
      <h2>Your 2023 Yearly Income Level: ${{ income }}</h2>
      <input type="range" min="0" max="300000" step="1" v-model="income" @input="updateTaxRates" />
      <p></p>
    </div>
  
    <div class="tax-summary-card">
  <h2>Estimated Taxes Owed: ${{ currency(totalTaxes) }}</h2>
  <p>Federal Tax: ${{ currency(federalTax) }}</p>
  <p>Provincial Tax: ${{ currency(provincialTax) }}</p>
  <p v-if="selectedProvince === 'Quebec'">QPP Contribution: ${{ currency(qppContribution) }}</p>
    <p v-else>CPP Contribution: ${{ currency(cppContribution) }}</p>
  <p>EI Premium: ${{ currency(eiPremium) }}</p> 
    <h3>Total Net Income (Annual): ${{ currency(annualNetIncome) }}</h3> <!-- Display Total Net Income -->

</div>
  

      <div class="take-home-section">

    <div class="frequency-dropdown">
      <label for="frequency">Pay Frequency:</label>
      <select id="frequency" v-model="selectedFrequency" @change="calculateTakeHomePay">
        <option value="biweekly">Bi-Weekly</option>
        <option value="semimonthly">Semi-Monthly</option>
        <option value="monthly">Monthly</option>
      </select>
      
    </div>    <h2>Your Take-Home Pay: ${{ formattedTakeHomePay }}</h2>
  </div>
    </div>
<br><br><br><br><br><br>
</template>

  
  <script>
export default {
  name: 'AppTaxes',
  data() {
    return {
      income: 50000,
      federalTax: 0,
      provincialTax: 0,
      cppContribution: 0,
      eiPremium: 0,
      totalTaxes: 0,
      provinces: [
        'Newfoundland and Labrador',
        'Prince Edward Island',
        'Nova Scotia',
        'New Brunswick',
        'Ontario',
        'Manitoba',
        'Saskatchewan',
        'Alberta',
        'British Columbia',
        'Yukon',
        'Northwest Territories',
        'Nunavut',
        'Quebec'
      ],
      selectedProvince: 'Ontario',
      selectedFrequency: 'monthly', // Default value
      formattedTakeHomePay: '0.00',
      annualNetIncome: 0,
      
    };
    
  },
  
  methods: {
    updateTaxRates() {
      this.federalTax = this.calculateFederalTax(this.income);
      this.provincialTax = this.calculateProvincialTax(this.income, this.selectedProvince);
      if (this.selectedProvince === 'Quebec') {
        // Calculate QPP contribution
        this.qppContribution = this.calculateQPP(this.income);
      } else {
        // Calculate CPP contribution
        this.cppContribution = this.calculateCPP(this.income);
      }
      this.eiPremium = this.calculateEiPremium(this.income);

      this.totalTaxes = this.federalTax + this.provincialTax + this.cppContribution + this.eiPremium;
      if (this.selectedProvince === 'Quebec') {
        this.totalTaxes = this.federalTax + this.provincialTax + this.qppContribution + this.eiPremium;
      }

      // Calculate annual net income
      this.annualNetIncome = this.income - this.totalTaxes;
    },
    currency(value) {
      return parseFloat(value).toFixed(2);
    },
    calculateFederalTax(income) {
  let tax = 0;
  if (income <= 53359) tax = income * 0.15;
  else if (income <= 106717) tax = 53359 * 0.15 + (income - 53359) * 0.205;
  else if (income <= 165430) tax = 53359 * 0.15 + (106717 - 53359) * 0.205 + (income - 106717) * 0.26;
  else if (income <= 235675) tax = 53359 * 0.15 + (106717 - 53359) * 0.205 + (165430 - 106717) * 0.26 + (income - 165430) * 0.29;
  else tax = 53359 * 0.15 + (106717 - 53359) * 0.205 + (165430 - 106717) * 0.26 + (235675 - 165430) * 0.29 + (income - 235675) * 0.33;
  return tax;
},
    calculateProvincialTax(income, province) {
      let tax = 0;
      const taxBrackets = {
        'Newfoundland and Labrador': [
          { threshold: 41457, rate: 0.087 },
          { threshold: 82913, rate: 0.145 },
          { threshold: 148027, rate: 0.158 },
          { threshold: 207239, rate: 0.178 },
          { threshold: 264750, rate: 0.198 },
          { threshold: 529500, rate: 0.208 },
          { threshold: 1059000, rate: 0.213 },
          { rate: 0.218 },
        ],
        'Prince Edward Island': [
          { threshold: 31984, rate: 0.098 },
          { threshold: 63969, rate: 0.138 },
          { rate: 0.167 },
        ],
        'Nova Scotia': [
          { threshold: 29590, rate: 0.0879 },
          { threshold: 59180, rate: 0.1495 },
          { threshold: 93000, rate: 0.1667 },
          { threshold: 150000, rate: 0.175 },
          { rate: 0.21 },
        ],
        'New Brunswick': [
          { threshold: 47715, rate: 0.094 },
          { threshold: 95431, rate: 0.14 },
          { threshold: 176756, rate: 0.16 },
          { rate: 0.195 },
        ],
        'Ontario': [
          { threshold: 49231, rate: 0.0505 },
          { threshold: 98463, rate: 0.0915 },
          { threshold: 150000, rate: 0.1116 },
          { threshold: 220000, rate: 0.1216 },
          { rate: 0.1316 },
        ],
        'Manitoba': [
          { threshold: 36842, rate: 0.108 },
          { threshold: 79625, rate: 0.1275 },
          { rate: 0.174 },
        ],
        'Saskatchewan': [
          { threshold: 49720, rate: 0.105 },
          { threshold: 142058, rate: 0.125 },
          { rate: 0.145 },
        ],
        'Alberta': [
          { threshold: 142292, rate: 0.1 },
          { threshold: 170751, rate: 0.12 },
          { threshold: 227668, rate: 0.13 },
          { threshold: 341502, rate: 0.14 },
          { rate: 0.15 },
        ],
        'British Columbia': [
          { threshold: 45654, rate: 0.0506 },
          { threshold: 91310, rate: 0.077 },
          { threshold: 104835, rate: 0.105 },
          { threshold: 127299, rate: 0.1229 },
          { threshold: 172602, rate: 0.147 },
          { threshold: 240716, rate: 0.168 },
          { rate: 0.205 },
        ],
        'Yukon': [
          { threshold: 53359, rate: 0.064 },
          { threshold: 106717, rate: 0.09 },
          { threshold: 165430, rate: 0.109 },
          { threshold: 500000, rate: 0.128 },
          { rate: 0.15 },
        ],
        'Northwest Territories': [
          { threshold: 48326, rate: 0.059 },
          { threshold: 96655, rate: 0.086 },
          { threshold: 157139, rate: 0.122 },
          { rate: 0.1405 },
        ],
        'Nunavut': [
          { threshold: 50877, rate: 0.04 },
          { threshold: 101754, rate: 0.07 },
          { threshold: 165429, rate: 0.09 },
          { rate: 0.115 },
        ],
        'Quebec': [
          { threshold: 49275, rate: 0.14 },
          { threshold: 98540, rate: 0.19 },
          { threshold: 119910, rate: 0.24 },
          { threshold: 119911, rate: 0.2575 },
          { rate: 0.2575 },
        ],
      };

      let remainingIncome = income;
      for (const bracket of taxBrackets[province]) {
        if (bracket.threshold && remainingIncome > bracket.threshold) {
          tax += bracket.threshold * bracket.rate;
          remainingIncome -= bracket.threshold;
        } else {
          tax += remainingIncome * bracket.rate;
          break;
        }
      }
      return tax;
    },
    calculateQPP(income) {
      // Logic to calculate QPP based on 2023 rates
      const maxInsurableEarnings = 66600;
      const exemption = 3500;
      const rate = 0.0640;
      const taxableIncome = Math.max(0, Math.min(income, maxInsurableEarnings) - exemption);
      return taxableIncome * rate;
    },

    calculateCPP(income) {
      // Logic to calculate CPP based on 2023 rates
      const maxInsurableEarnings = 66600;
      const exemption = 3500;
      const rate = 0.0595;
      const taxableIncome = Math.max(0, Math.min(income, maxInsurableEarnings) - exemption);
      return taxableIncome * rate;
    },

   
    calculateEiPremium(income) {
      const eiMaxInsurableIncome = 61500;
      const eiPremiumRate = 0.0163;

      return Math.min(income, eiMaxInsurableIncome) * eiPremiumRate;
    },
    calculateTakeHomePay() {
      const annualTakeHome = this.income - this.totalTaxes;
      let takeHomePay;
      switch (this.selectedFrequency) {
        case 'biweekly':
          takeHomePay = annualTakeHome / 26;
          break;
        case 'semimonthly':
          takeHomePay = annualTakeHome / 24;
          break;
        case 'monthly':
          takeHomePay = annualTakeHome / 12;
          break;
      }
      this.formattedTakeHomePay = takeHomePay.toFixed(2);
    },
  },

watch: {
  income() {
    this.updateTaxRates(); // Recalculate taxes if income changes
    this.calculateTakeHomePay(); // Update take-home pay
  },

  // ... other watchers if necessary ...
},

created() {
  this.updateTaxRates(); // Initial calculation when the component is created
},

// ... other component options if necessary ...
};
</script>
   
  
<style scoped>
.taxes-page {
  padding: 20px;
  background-color: #4A148C;
  border-radius: 15px;
}

.stingycat-section,
.tax-summary-card,
.take-home-section, 
.tax-slider-section {
  border-radius: 15px;
  background-color: #f5f5f5; /* Light grey for contrast */
  padding: 20px;
  margin: 20px 0;
}

.stingycat-explanation {
  display: flex;
  align-items: center;
}

.stingycat-explanation img {
  width: 300px;
  margin-right: 20px;
}

.tax-calculation-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px; /* Adjust as needed */
}

.tax-summary-card,
.take-home-section {
  flex: 1; /* Each section takes up half the space */
}

.frequency-dropdown,
.province-dropdown {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border-radius: 15px;
  background-color: #2c2c2c; /* Dark background for dropdowns */
  margin-bottom: 20px;
}

.frequency-dropdown label,
.province-dropdown label {
  color: white;
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 1px 1px 2px black;
}

.province-dropdown select,
.frequency-dropdown select {
  padding: 10px 15px;
  font-size: 1em;
  border: none;
  border-radius: 15px;
  background-color: #404040; /* Slightly lighter background for the dropdown */
  color: white;
  cursor: pointer;
  outline: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.province-dropdown select:focus,
.frequency-dropdown select:focus {
  background-color: #555555; /* A shade lighter on focus */
}

.province-dropdown select option,
.frequency-dropdown select option {
  padding: 10px 15px;
  background-color: #404040;
  color: white;
  border-radius: 15px;
}

.province-dropdown select option:hover,
.province-dropdown select option:focus,
.frequency-dropdown select option:hover,
.frequency-dropdown select option:focus {
  background-color: #ffa500; /* Orange highlight for selected/hovered option */
  color: black;
}

.tax-slider-section input[type=range] {
  width: 100%; /* Full width to maximize visibility */
  height: 15px; /* Increased height of the slider track */
  background: #ddd; /* Light grey track */
  outline: none; /* Remove outline */
  opacity: 0.7; /* Partial transparency */
  -webkit-transition: 0.2s; /* Transition for smoothness */
  transition: opacity 0.2s;
}

.tax-slider-section input[type=range]:hover {
  opacity: 1; /* Fully opaque on hover */
}

.tax-slider-section input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default appearance */
  appearance: none;
  width: 25px; /* Width of the handle */
  height: 25px; /* Height of the handle */
  background: #4A148C; /* Color of the handle */
  cursor: pointer; /* Cursor changes to a pointer when hovered over */
  border-radius: 50%; /* Round shape */
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5); /* Subtle shadow for depth */
}

.tax-slider-section input[type=range]::-moz-range-thumb {
  width: 25px; /* Width of the handle */
  height: 25px; /* Height of the handle */
  background: #4A148C; /* Color of the handle */
  cursor: pointer;
  border-radius: 50%; /* Round shape */
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
}

.income-slider {
  width: 100%;
  height: 8px; /* Can adjust for a thicker slider track */
  background: linear-gradient(
    to right,
    #4A148C 0%,
    #4A148C calc((61500 / 300000) * 100%), /* EI Cap */
    #ffa500 calc((61500 / 300000) * 100%),
    #ffa500 calc((66600 / 300000) * 100%), /* CPP Cap */
    #ddd calc((66600 / 300000) * 100%),
    #ddd 100%
  );
  border-radius: 5px;
  outline: none;
}

/* Thumb (Handle) Styling */
.income-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background: #fff;
  border: 2px solid #4A148C;
  border-radius: 50%;
  cursor: pointer;
}

.income-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #fff;
  border: 2px solid #4A148C;
  border-radius: 50%;
  cursor: pointer;
}
</style>